/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Statut d'une carte UI
 * @export
 * @interface CardStatusDto
 */
export interface CardStatusDto {
    /**
     * Statut visuel de la carte.
     * - Valid: Carte complète (vert)
     * - Critical: Action requise (rouge)
     * - InProgress: En cours (jaune)
     * 
     * @type {string}
     * @memberof CardStatusDto
     */
    status: CardStatusDtoStatusEnum;
    /**
     * Si la carte est cliquable/éditable
     * @type {boolean}
     * @memberof CardStatusDto
     */
    isDisabled: boolean;
    /**
     * Clé i18n pour message tooltip (optionnel)
     * @type {string}
     * @memberof CardStatusDto
     */
    message?: string;
}


/**
 * @export
 */
export const CardStatusDtoStatusEnum = {
    Valid: 'Valid',
    Critical: 'Critical',
    InProgress: 'InProgress'
} as const;
export type CardStatusDtoStatusEnum = typeof CardStatusDtoStatusEnum[keyof typeof CardStatusDtoStatusEnum];


/**
 * Check if a given object implements the CardStatusDto interface.
 */
export function instanceOfCardStatusDto(value: object): value is CardStatusDto {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('isDisabled' in value) || value['isDisabled'] === undefined) return false;
    return true;
}

export function CardStatusDtoFromJSON(json: any): CardStatusDto {
    return CardStatusDtoFromJSONTyped(json, false);
}

export function CardStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CardStatusDto {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'isDisabled': json['isDisabled'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function CardStatusDtoToJSON(json: any): CardStatusDto {
    return CardStatusDtoToJSONTyped(json, false);
}

export function CardStatusDtoToJSONTyped(value?: CardStatusDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'isDisabled': value['isDisabled'],
        'message': value['message'],
    };
}

